import type { PoliciesPort, PolicyStatus } from './ports.ts';
import type { WorkerClient } from './worker.ts';

// The Worker keeps the accepted versions (policyAcceptanceCurrent). Policy
// pages are the public help pages until they move into the app at cutover.
const HELP_ORIGIN = 'https://www.guildite.com';

function withOrigin(status: PolicyStatus): PolicyStatus {
  const absolute = (url: string) => (url.startsWith('/') ? `${HELP_ORIGIN}${url}` : url);
  return { ...status, termsUrl: absolute(status.termsUrl), privacyUrl: absolute(status.privacyUrl) };
}

export function createPolicies(worker: WorkerClient): PoliciesPort {
  return {
    status: async () => withOrigin(await worker.call<PolicyStatus>('get_policy_acceptance')),
    accept: async ({ termsVersion, privacyVersion }, adult) => withOrigin(await worker.call<PolicyStatus>('accept_policies', {
      termsAccepted: true, privacyAcknowledged: true, termsVersion, privacyVersion,
      ...(adult ? { adultConfirmed: true, adultConfirmedFrom: adult } : {}),
    })),
  };
}
